import Address from "./Address";
import CountryLanguage from "./CountryLanguage";
import Currency from "./Currency";

const LocationModal = () => {
  return (
    <>
      <div
        className="modal fade"
        id="lancurModal"
        aria-labelledby="lancurModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-xl modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header border-0">
              <div
                data-bs-dismiss="modal"
                aria-label="Close"
                className=" mt-1 cursor-pointer"
              >
                <i className="bi bi-x fs-4 text-black"></i>
              </div>
            </div>
            <div className="modal-body mb-4">
              <nav>
                <div className="nav nav-tabs" id="nav-tab" role="tablist">
                  <button
                    className="nav-link active w-auto fs-6 text-black fw-normal"
                    id="nav-language-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#nav-language"
                    type="button"
                    role="tab"
                    aria-controls="nav-language"
                    aria-selected="true"
                  >
                    Country & Language
                  </button>
                  <button
                    className="nav-link w-auto fs-6 text-black fw-normal"
                    id="nav-currency-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#nav-currency"
                    type="button"
                    role="tab"
                    aria-controls="nav-currency"
                    aria-selected="false"
                  >
                    Currency
                  </button>
                  <button
                    className="nav-link w-auto fs-6 text-black fw-normal"
                    id="nav-adress-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#nav-adress"
                    type="button"
                    role="tab"
                    aria-controls="nav-adress"
                    aria-selected="false"
                  >
                    Your Address
                  </button>
                </div>
              </nav>
              <div className="tab-content" id="nav-tabContent">
                <div
                  className="tab-pane fade show active"
                  id="nav-language"
                  role="tabpanel"
                  aria-labelledby="nav-language-tab"
                >
                  <CountryLanguage />
                </div>
                <div
                  className="tab-pane fade"
                  id="nav-currency"
                  role="tabpanel"
                  aria-labelledby="nav-currency-tab"
                >
                  <Currency />
                </div>
                <div
                  className="tab-pane fade"
                  id="nav-adress"
                  role="tabpanel"
                  aria-labelledby="nav-adress-tab"
                >
                  <Address />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LocationModal;
